// Internal deps
import axios from "axios";
import { constantsSession } from "../constants/constants";
import { getItemStorage, clearStorage } from "../utils/utils";

let appContext;

export const injectContext = (context) => {
  appContext = context;
};

const expiredLogout = () => {
  if (appContext) appContext.onLogOut();
  clearStorage();
};

const requestHeaderConfig = async (config) => {
  const token_date = getItemStorage(constantsSession.ACCESS_TOKEN_DATE, false);
  const token_expires_in = getItemStorage(
    constantsSession.ACCESS_TOKEN_EXPIRE_IN,
    false
  );
  const token = getItemStorage(constantsSession.ACCESS_TOKEN, false);

  // Validates the expiration date/time for which the token remains valid
  const token_date_valid = Number(token_date) + Number(token_expires_in * 1000);

  const actual_date = new Date().getTime();

  // Ensures that the current date/time is earlier than the token's expiration date
  const isValidToken = actual_date < token_date_valid;

  // Builds the configuration header
  const newConfig = {
    ...config,
  };
  if (token) {
    newConfig.headers.Authorization = `Bearer ${token}`;
    newConfig.headers["Content-Type"] = "application/json";
  }

  // If the token has already expired (current date/time is later than the expiration date)
  // call the service to refresh the token
  if (!isValidToken) {
    expiredLogout();
  }

  return newConfig;
};

const DEFAULT_ERROR_MSG = 'Ocurrió un error inesperado. Comunicate con soporte Y-Click.'

const apiInterceptors = (instance, hasToken = false) => {
  if (hasToken) {
    instance.interceptors.request.use(
      (config) => requestHeaderConfig(config),
      (error) => Promise.reject(error)
    );
  } else {
    instance.interceptors.request.use(
      (config) => config,
      (error) => Promise.reject(error)
    );
  }

  instance.interceptors.response.use(
    (response) => Promise.resolve(response),
    (error) => {
      let errorAfter = error.response;

      if (error.response) {
        const message =
          (errorAfter?.data && (errorAfter.data?.message || errorAfter.data?.errorMessage
            || errorAfter.data?.Message)) ||
          DEFAULT_ERROR_MSG;

        errorAfter = { message };

      } else if (!axios.isCancel(error)) {
        errorAfter = { message: DEFAULT_ERROR_MSG };
      }

      return Promise.reject(errorAfter);
    }



  );
};

export default apiInterceptors;